module.exports = __webpack_public_path__ + "img/innovation.1a8fca6e.jpg";